<template>
  <div class="new-home">

    <van-nav-bar
        title="附近药店"
        
        
        
        @click-left="onClickLeft"
        @click-right="onClickRight"
        ></van-nav-bar>

 <van-search
    v-model="drugValue"
    show-action
    placeholder="请输入搜索关键词"
    @search="onSearch"
    @cancel="onCancel"
  />

    <div class="nearby-section">
      <div class="nearby-list">
        <div class="nearby-item" v-for="(item, idx) in nearbyList" :key="idx" >
          <img :src="item.logo||require('../../static/img/yaodian1.png')" class="nearby-logo" @click="selectShop(item)"/>
          <div class="nearby-info" @click="selectShop(item)">
            <div class="nearby-name">{{item.supplierName}}</div>
            <div class="nearby-namex" v-if="item.merchantName">{{item.merchantName}}</div>
            <div class="nearby-address">{{item.supplierAddress}}</div>
          </div>
          <div class="nearby-distance">
            <img @click="calPhone(item.supplierTel)" :src="require('../../static/img/call_phone.png')" class="nearby-distance-logo" />
            <div @click="selectShop(item)">
                <van-icon name="location" color="#ee0a24"/>
                {{item.distanceStr}}
            </div>            
          </div>
        </div>
      </div>
      <div style="height:100px;">&nbsp;</div>
    </div>

    <van-overlay :show="loading" z-index="1000">
      <div class="loading-wrapper">
        <van-loading type="spinner" size="30px" vertical>
          加载中...
        </van-loading>
      </div>
    </van-overlay>


    <div v-if="selectedShop" class="overlay" @click="closePanel"></div>
    <!--
    <div v-if="selectedShop" class="bottom-panel">
      <p>前往：{{ selectedShop.supplierName }}</p>
      <div class="btn-group">
        <button @click="openInBaiduMap">百度地图</button>
        <button @click="openInGaodeMap">高德地图</button>
        <button @click="closePanel">取消</button>
      </div>
    </div> -->
    <!-- 底部菜单 -->
    <div class="bottom-menu-content" v-if="selectedShop">
       <div class="menu-item">前往：{{ selectedShop.supplierName }}</div>
      <div class="menu-item" @click="openInBaiduMap">百度地图</div>
      <div class="menu-item" @click="openInGaodeMap">高德地图</div>
      <div class="menu-item cancel-item" @click="closePanel">取消</div>
    </div>

  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import jingweiduTransApi from '@/utils/jingweiduTrans.js';

export default {
  name: 'nearestDurgPage',
  data() {
    return {
			targetMode:"min",
			current: 1,
			hasPwd: '', //是否设置过密码，没有则不允许进入京东商城
      drugValue:'',
      
      lysCstUserId:null,
      b:null,
      c:null,

      loading: false,

      nearbyList: [

      ],

      latitude: null,//纬度
      longitude: null,//精度

      selectedShop: null,//选择的门店
    }
  },
  	// 生命周期 - 创建完成（可以访问当前this实例）
	created() {

    //this.lysCstUserId = sessionStorage.getItem('lysCstUserId');

	  let {a,b,c} = this.$route.query; //a=lysCstUserId&b=12wei随机码&c=签名

    if(!a){
        alert("错误请请求");
    }else{

      this.lysCstUserId = a;

      this.b = b;

      this.c = c;

      this.getLoactionByH5();
    }

    //sessionStorage.setItem('cstFullName', "杨长发");
		//sessionStorage.setItem('userPlnCode', "P0001");
	},
   mounted() {
     //this.getLoactionX();
   },
	methods: {

        onSearch(){
          this.queryDrugList(this.drugValue);
        },

        onCancel(){
            this.queryDrugList("");
        },

        //拨打电话
        calPhone(phone){
          window.location.href = `tel:${phone}`;
        },


        selectShop(shop) {
          this.selectedShop = shop
        },

        closePanel() {
          this.selectedShop = null
        },

      // ========== 打开百度地图（使用 BD-09 坐标） ==========
      //item.posWeidu  item.posJingdu
          async openInBaiduMap() {
           
            const dest = this.selectedShop
 
            // 转换终点坐标（GCJ-02 → BD-09）
            const bdDest = {lat:dest.posWeidu, lng:dest.posJingdu};

            const scheme = `baidumap://map/marker?location=${bdDest.lat},${bdDest.lng}&title=${dest.supplierName}&content=${dest.supplierName}&src=webapp`;
            const web = `https://api.map.baidu.com/marker?location=${bdDest.lat},${bdDest.lng}&title=${dest.supplierName}&output=html`;
            this.openMap(scheme, web);
          },

          // ========== 打开高德地图（使用 GCJ-02，无需转换） ==========
          async openInGaodeMap() {
            //const origin = await this.getCurrentPosition()
            const dest = this.selectedShop
            console.log(dest);
            const [lng, lat] = jingweiduTransApi.bd09ToGcj02(dest.posJingdu, dest.posWeidu);//{lat:dest.posWeidu, lng:dest.posJingdu};
            //const [startGcjLng, startGcjLat] = jingweiduTransApi.bd09ToGcj02(this.longitude, this.latitude);//this.latitude, lng:this.longitude
            
            const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

            let scheme = isIOS
              ? `iosamap://navi?sourceApplication=webapp&poiname=${dest.supplierName}&lat=${lat}&lon=${lng}&dev=0`
              : `amapuri://route/plan/?dlat=${lat}&dlon=${lng}&dname=${dest.supplierName}&dev=0&t=0`;

            const web = `https://uri.amap.com/marker?position=${lng},${lat}&name=${dest.supplierName}`;
            this.openMap(scheme, web);

          },

          openMap(schemeUrl, webUrl) {


           const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

           if(isIOS){//苹果打不开
              window.open(webUrl, '_blank');
              return;
           }else{
              // 安卓可用 iframe 尝试唤起
              const iframe = document.createElement('iframe');
              iframe.style.display = 'none';
              iframe.src = schemeUrl;
              document.body.appendChild(iframe);
              
              setTimeout(() => {
                document.body.removeChild(iframe);
                window.open(webUrl, '_blank');
              }, 1000);
              return;
           }
           
          },

        openBaiduMapWithAddress(item) {

            // 经纬度坐标（示例：天安门）
            //const lat = 39.915;
            //const lng = 116.404;
            const title = encodeURIComponent(item.supplierName);
            //const url = `https://api.map.baidu.com/marker?location=${bdLat},${bdLng}&title=我的位置&content=当前位置&output=html&src=your_app_name`;
            // 构建百度地图URL
            const url = "https://api.map.baidu.com/marker?location="+item.posWeidu+","+item.posJingdu+"&title="+title+"&output=html&src=lys";
            
            // 新窗口打开
            window.open(url, '_blank');

        },
		onChange() {

		},
	
    //查询附近药店
    queryDrugList(val){
      
      if(!this.lysCstUserId){
          
          this.toLoginPage();

          return;
      }

			let data = {
            a:this.lysCstUserId,
            b:this.b,
            c:this.c,
            currentLon:this.longitude,//  精度
            currentLat:this.latitude,//  维度
            keyData:val,
            pageNo:1,
            pageSize:50,
            shopType:'',//  门店类型（见4.3门店类型1药店2体检3牙科4	眼科5医院6中医）
			}
      
      this.loading = true;
      
			this.$getRequestData20('findNearestN20', data)
			.then(result =>{
        
        this.loading = false;

				console.log(result);

				if(result.resultCode !== '0000'){
 					
					
					this.$toast.fail(result.msg);

					
				}else{

          let supplierDataItem = result.bizData;
          if(supplierDataItem){
            for (const supplierData of supplierDataItem) {
              supplierData.distanceStr = this.calDistanceStr(supplierData.distance);
            }
          }


					this.nearbyList = supplierDataItem;

				}
			})
			.catch(err => {

        this.loading = false;

				console.log(err);
				this.$toast.fail(err);
				
			})
    },

    calDistanceStr(distance){
            // 验证输入是否为非负数
            if (isNaN(distance) || distance < 0) {

                return;
            }
            const meters = parseFloat(distance);
            // 格式化距离
            let result;
            if (meters < 1000) {
                // 小于1000米，使用米为单位
                result = `${meters.toFixed(0)}米`;
            } else {
                // 大于等于1000米，转换为千米并保留2位小数
                const kilometers = meters / 1000;
                result = `${kilometers.toFixed(2)}千米`;
            }

            return result;
    },

		toLoginPage(){
			
			 this.$router.push({ path: '/login/loginPage' });
		},
    onClickLeft(){
        history.go(-1);
    },
    onClickRight()
    {
        this.$router.push({ path: '/' })
    }, 
    //根据h5获取地理位置
    getLoactionByH5() {
          if (!navigator.geolocation) {
            alert('您的浏览器不支持地理位置功能。');
            return
          }

          this.loading = true;

          navigator.geolocation.getCurrentPosition(
            (success) => {

              this.loading = false ;

              console.log('ge WGS-84坐标:', success.coords.longitude, success.coords.latitude);

              const bd = jingweiduTransApi.wgsToBaidu(success.coords.latitude, success.coords.longitude);
              console.log('ge 百度坐标:', bd.lng, bd.lat);

              this.latitude = bd.lat;
              this.longitude = bd.lng;

              this.queryDrugList();
            },
            (fail) => {

              this.loading = false ;
              
              console.error('Geolocation error:', fail)
              //alert('无法获取位置，请检查权限或网络设置。');

              // 2. 失败则降级到 IP 定位
              fetch('https://ipapi.co/json/')
                  .then(response => response.json())
                  .then(data => {
                      //this.latitude = data.latitude;
                      //this.longitude = data.longitude;

                      console.log('ip WGS-84坐标:', data.longitude, data.latitude);

                      const bd = jingweiduTransApi.wgsToBaidu(data.latitude, data.longitude);
                      console.log('ip 百度坐标:', bd.lng, bd.lat);

                      this.latitude = bd.lat;
                      this.longitude = bd.lng;

                      this.queryDrugList();
                    })

            },
            {
              enableHighAccuracy: true, // 高精度
              timeout: 10000,           // 超时时间（毫秒）
              maximumAge: 60000         // 允许使用缓存位置（1分钟内）
            }
          )
    },

    //初始化wx-js
    getLoactionX() {
            let wxAppId = process.env.VUE_APP_WX_APP_ID;// lys:724039475503837184   yzf:1166419017226006528

            let bizData = {
                wxAppId: wxAppId, //默认值(配置区分生产/测试环境)
                httpUrl: window.location.href //当前页面url
            }
           
            
            ///pc/wx/gzhweixinMgt/getSignature
            this.$getRequestCommon('/pc/wx/gzhweixinMgt/getSignature', bizData)
            .then(result =>{

              console.log(result);

              if(result.resultCode !== '0000'){
                

                this.$toast.fail(result.msg);

              }else{
                   let bizDataJson = result.bizData;

                   let appId = bizDataJson.wxGzhCorpCode; // 必填，公众号的唯一标识
                   let timestamp = bizDataJson.timestamp; // 必填，生成签名的时间戳
                   let nonceStr = bizDataJson.nonceStr; // 必填，生成签名的随机串
                   let signature = bizDataJson.signature; // 必填，签名
                   
                   //wx
                    wx.config({
                      debug: false, // 调试模式，生产环境建议关闭
                      appId: appId,
                      timestamp: timestamp,
                      nonceStr: nonceStr,
                      signature: signature,
                      jsApiList: ['getLocation'] // 需要使用的JS接口列表，凡是要调用的接口都需要传进来
                    });

                    wx.ready(() => {
                      // 第三步：配置成功后再调用getLocation
                      wx.getLocation({
                        type: 'gcj02', // 默认为wgs84的gps坐标，如果要直接给第三方地图用，可以选择gcj02
                        success: (res) => {
                          this.latitude = res.latitude;
                          this.longitude = res.longitude;
                          // 你也可以在这里将坐标发送到服务器或其他处理
                          console.log('纬度：' + res.latitude);
                          console.log('经度：' + res.longitude);

                          //查询
                          this.queryDrugList("");
                        },
                        fail: (err) => {
                          console.error('获取位置失败：', err);
                          alert('获取位置失败，请检查是否拒绝了权限。错误信息：' + JSON.stringify(err));
                        }
                      });
                    });

                    wx.error((err) => {
                      console.error('JS-SDK配置失败：', err);
                      alert('JS-SDK配置失败，请检查配置。错误信息：' + JSON.stringify(err));
                    });                   
              }
            })
            .catch(err => {
              console.log(err);
              this.$toast.fail(err);
              
            })            
           
        },

	},
}



</script>

<style scoped>
.new-home { background: #f7f8fa; }
.top-bar { display: flex; align-items: center; justify-content: space-between; padding: 16px; background: #2176ff; color: #fff; }
.location { font-size: 16px; }
.logo { height: 32px; }
.top-icons { display: flex; align-items: center; }
.dot, .line, .circle { width: 8px; height: 8px; border-radius: 50%; background: #fff; margin-left: 8px; }
.line { width: 16px; border-radius: 4px; }
.direct-section { 
  position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    /* align-items: center; */
    overflow: hidden;
    z-index: 1;
    padding: 0px 0 24px;
    border-bottom-left-radius: 110vw 120px;
    border-bottom-right-radius: 110vw 120px;
    background: #2176ff;
    height: 170px;
    color: #fff;
}
.direct-item { 
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 18px;
    margin-top: 25px; 
}
.direct-item i { font-size: 32px; margin-bottom: 4px; }
.service-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; background: #fff; padding: 12px 0 24px;     margin: 12px;  border-radius: 15px;}
.service-item { display: flex; flex-direction: column; align-items: center; font-size: 14px; color: #333; }
.service-icon {  height: 36px; margin-bottom: 4px; }
.banner {    margin: 15px 10px; }
.banner img { width: 100%; border-radius: 8px; }
/* .nearby-section { background: #fff; margin: 0 0 16px; border-radius: 8px; padding: 16px; } */
.nearby-title { 
  font-size: 18px;     
  margin-bottom: 8px;
  text-align: left;
  margin-left: 15px; 
}
.nearby-title-right { 
  font-size: 15px;     
  margin-bottom: 8px;
  text-align: right;
  margin-left: 70%; 
}
.nearby-tabs { display: flex; gap: 16px; margin-bottom: 12px; }
.nearby-tabs span { font-size: 15px; color: #888; cursor: pointer; }
.nearby-tabs .active { color: #2176ff; font-weight: bold; border-bottom: 2px solid #2176ff; }
.nearby-list { background-color: #fff;
    margin: 5px 5px;
    /*border-radius: 15px;*/
    }
.nearby-item {  
  display: flex;  border-bottom: 1px solid #f0f0f0;     padding: 15px 10px; 
  >div {
    display: flex; 
    flex-direction: column;
    justify-content: space-around;
  }
}
.nearby-logo { width: 35px; height: 35px; border-radius: 8px; margin-right: 12px; }
.nearby-info { flex: 1; text-align: left;}
.nearby-name { font-size: 15px;  }
.nearby-namex { font-size: 13px;  margin-top: 3px;}
.nearby-address { font-size: 12px; color: #888;    margin-top: 5px; }
.nearby-distance {  font-size: 12px;   color: #888;    align-items: end; }
.nearby-distance-logo{ width: 20px;}


.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  color:blue;
}

.bottom-panel {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 20px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.btn-group button {
  width: 30%;
  padding: 10px;
  margin: 0 5px;
  border: none;
  border-radius: 5px;
  background: #007bff;
  color: white;
  cursor: pointer;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
}

.bottom-menu-content {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 15px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.bottom-menu-content.active {
  transform: translateY(0);
}

.menu-item {
  padding: 20px 30px;
  text-align: center;
  font-size: 16px;
  color: #333;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

.menu-item:last-child {
  border-bottom: none;
}

.cancel-item {
  color: #666;
}

/* 添加动画效果 */
@media (max-width: 768px) {
  .bottom-menu-content {
    border-radius: 16px 16px 0 0;
  }
}

</style>